module.exports = __webpack_public_path__ + "img/new-whatsapp.9fe74d7a.svg";